/* Defer a Swiper init until its container nears the viewport (300px margin).
   Falls back to immediate init when IntersectionObserver is unavailable. */
function initNearView(el, init) {
  if (!el) return;
  if (!('IntersectionObserver' in window)) { init(); return; }
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { io.disconnect(); init(); }
  }, { rootMargin: '300px 0px' });
  io.observe(el);
}


/* Stop a continuous-autoplay Swiper while it is off screen — it otherwise
   animates (and burns main-thread) for the whole page lifetime. */
function pauseOffscreen(el, sw) {
  if (!el || !sw || !sw.autoplay || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { sw.autoplay.start(); }
    else { sw.autoplay.stop(); }
  }, { rootMargin: '100px 0px' });
  io.observe(el);
}

jQuery(document).ready(function($){


    var productOOS = false;


     initNearView(document.querySelector('.swiper-index-2026-slides'), function () {
     var swiperIngredientSliders = new Swiper('.swiper-index-2026-slides', {
        slidesPerView: 1.6,
        spaceBetween: 15,
        autoHeight: false,
        autoplay: false,   // ← disables autoplay

        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 32,
            }
        }

    });
     });

    
     // trigger the play button click
    // $('.fon-video-play').trigger('click');

    // wait a bit so player starts, then mute it
    // setTimeout(function(){
    //     const player = document.querySelector('.product-main-gallery mux-player');
    //     if (player){
    //     player.muted = true;
    //     }
    // }, 500);

    // $(document).on('click', '.product-main-gallery .fon-video-lazy-container mux-player', function () {
    //     const player = this;  // the clicked mux-player

    //     // Toggle mute
    //     player.muted = !player.muted;
    //     player.currentTime = 0;
    //     // Optional: restart from beginning if you want
    //     // player.currentTime = 0;

    //     // Play the video (user click allows autoplay)
    //     player.play?.().catch(() => {});
    //     const $container = $(this).closest('.fon-video-lazy-container');
        
    //     $container.addClass('playing');
    // });


    // setInteval(function(){

    //     $('.gift-product__card.gift-product__card--active').find('.per-day').html();

    // },1000);

    function checkPerDay(){
        var perDay = $('.gift-product__card.gift-product__card--active').find('.per-day').html();
        $('.per-day-dynamic').html(perDay);
        $('.per-day-dynamic-wrapper').addClass('active');
    }
   

    $('#try-onelife').on('click', function(e) {
      e.preventDefault(); // Prevent default link behavior

      $.magnificPopup.close();

      // Scroll smoothly to #gift-product
      $('html, body').animate({
          scrollTop: $('#gift-product').offset().top
      }, 600); // 600ms scroll duration
  });

    // Fisher-Yates shuffle function
    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    // Loop over each slider
    // Each card-reviews fader lazy-inits as it nears the viewport
    $('.swiper-gift-card-reviews-slider').each(function (index, slider) {
        initNearView(slider, function () {
        const $slider = $(slider);
        const $wrapper = $slider.find('.swiper-wrapper');
        const $slides = $wrapper.children().toArray();

        // Shuffle slides once before initializing Swiper
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;

        if (isDesktop) {
            shuffleArray($slides).forEach(slide => $wrapper.append(slide));
        }

        // Initialize Swiper
        const swiperInstance = new Swiper(slider, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            // loop: true,
            loop: isDesktop,
            speed: 700,
            autoplay: { delay: 4000, disableOnInteraction: false },
            observeParents: true,
        });
        });
    });

    $(document).on('click','.slide-up-footer button.slide-up-close',function(){
        $.magnificPopup.close();
    });


// Only activate swiper on mobile
if ($(window).width() <= 768) {

  // Wrap all cards in a swiper-wrapper dynamically
  $('.scientific-experts__grid').wrapInner('<div class="swiper-wrapper"></div>');

  // Add swiper-slide class to each card
  $('.scientific-experts__grid .scientific-experts__card').addClass('swiper-slide');

  // Add pagination container (optional)
  if ($('.scientific-experts__grid').find('.swiper-pagination').length === 0) {
    $('<div class="swiper-pagination"></div>').appendTo('.scientific-experts__grid');
  }

  // Initialize Swiper
  initNearView(document.querySelector('.scientific-experts__grid'), function () {
  var expertsSwiper = new Swiper('.scientific-experts__grid', {
    slidesPerView: 1.1,       // show part of next slide
    spaceBetween: 16,
    loop: true,                // make it loop infinitely
    grabCursor: true,
    autoplay: {                // add autoplay
      delay: 3000,             // 3 seconds per slide
      disableOnInteraction: false, // keep autoplay even after user interaction
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });
  });
}


    const swiperProductCarousel = new Swiper('.swiper-gift-product__carousel', {
        slidesPerView: 3,
        spaceBetween: 20,
        speed: 1600,
        grabCursor: true,
        centeredSlides: true,
        initialSlide: 1, // Start at 2nd slide
         breakpoints: {
            0: {              // phones
            slidesPerView: 3,
            spaceBetween: 10,
            },
        }
    });

    // Listen for slide change
    swiperProductCarousel.on('slideChange', function () {
        // Get the currently active slide
        const activeSlide = swiperProductCarousel.slides[swiperProductCarousel.activeIndex];
        
        // Get the data attribute
        const productData = activeSlide.getAttribute('data-fon-product');
        
        $('.gift-product__tabs > button').removeClass('gift-product__tab--active');
        $('.gift-product__tabs > button[data-tab="'+productData+'"]').addClass('gift-product__tab--active');


        $('.gift-product__card').removeClass('gift-product__card--active');
        $('.gift-product__card[data-tab="'+productData+'"]').addClass('gift-product__card--active');

        checkPerDay();
    });

    // When a tab is clicked
    $('.gift-product__tabs > button').on('click', function() {
        const tab = $(this).data('tab'); // Get the tab's data-tab


        $('.gift-product__tabs > button').removeClass('gift-product__tab--active');
        $('.gift-product__tabs > button[data-tab="'+tab+'"]').addClass('gift-product__tab--active');


        $('.gift-product__card').removeClass('gift-product__card--active');
        $('.gift-product__card[data-tab="'+tab+'"]').addClass('gift-product__card--active');

        // alert(tab);

        // Find the index of the slide that matches this tab
        const targetIndex = swiperProductCarousel.slides.findIndex(slide => 
            slide.getAttribute('data-fon-product') === tab
        );

        if (targetIndex !== -1) {
            swiperProductCarousel.slideTo(targetIndex); // Slide to that slide
        }
        checkPerDay();
    });

   // When a gift product card is clicked
$('.gift-product__card').on('click', function() {
    const $thisCard = $(this);             // The clicked card
    const tab = $thisCard.data('tab');     // Get the card's data-tab

    // Toggle active class
    $('.gift-product__card').removeClass('gift-product__card--active');
    $(`.gift-product__card[data-tab="${tab}"]`).addClass('gift-product__card--active');

    // Find the index of the slide that matches this tab
    const targetIndex = swiperProductCarousel.slides.findIndex(slide => 
        slide.getAttribute('data-fon-product') === tab
    );

    if (targetIndex !== -1) {
        swiperProductCarousel.slideTo(targetIndex); // Slide to that slide
    }

    // Scroll only on mobile screens
    if ($(window).width() < 768) {
       
        // const cardOffsetTop = $thisCard.offset().top; // Distance from top of page
        // $('html, body').animate({
        //     scrollTop: cardOffsetTop - 100 // Scroll 100px above the card
        // }, 500); // 500ms smooth scroll
    

        checkPerDay();
    }
});


    $(document).on('click','.gift-product__add-btn',function(){


        // March 31, 2026 OneLife OOS. Oct 14: also when the section says the jars are out (data-oos)
        if (productOOS || $(this).closest('.gift-product').attr('data-oos') === 'true'){
            showOutOfStockPopup('onelife'); // OneLife
            return;
        }

        var button = $(this);
        button.prop('disabled',true);
        
        var buttonTextEl = button.find('.gift-product__btn-text');
        var buttonTextValue = buttonTextEl.html();
        

        var parent = $(this).parents('.gift-product__card');
        var tab = parent.data('tab');


        var orderFrom = 'conquesting_' + $('.gift-product').data('page');


        switch (tab){
            case 'duo':

                buttonTextEl.html('Preparing Your Protocol...');

                var specialOfferVariantID = parseInt(button.attr('data-variant-id'));
                var specialOfferVariantSellingPlanID = parseInt(button.attr('data-selling-plan-id'));

                var formData = {
                items: [
                    {
                        id: specialOfferVariantID,
                        quantity: 6,
                        selling_plan: specialOfferVariantSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'onelife_90d_duo',
                            '_bundle_group_id' : 'onelife_90d_duo',
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            '_offer' : 'onelife_90d_duo',
                            '_offer_product_type' : 'primary',
                            _order_from : orderFrom
                        }
                    }
                ]
                };

                if (false && !bottleOOS) /*free gift off*/ {
                    formData.items.push(
                        {
                            id: 53301741289656, // Free bottle variant ID
                            quantity: 2,
                            properties : {
                                '_offer' : 'onelife_90d_duo',
                                '_offer_product_type' : 'free',
                                _order_from : orderFrom
                            }
                        }
                    );
                }

                // if (false && !frotherOOS) /*free gift off*/ {
                //     formData.items.push(
                //         {
                //             id: 52887363551416, // Free frother variant ID
                //             quantity: 2,
                //             properties : {
                //                 '_offer' : 'onelife_90d_duo',
                //                 '_offer_product_type' : 'free',
                //                 _order_from : orderFrom
                //             }
                //         }
                //     );
                // }

                
                // 1️⃣ Check cart first
                $.getJSON('/cart.js', function(cart) {
                    const hasItems = cart.item_count > 0;

                    // 2️⃣ Add to cart
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify(formData),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function () {
                            
                            setTimeout(function(){
                                    button.prop('disabled',false);
                                    buttonTextEl.html(buttonTextValue);
                            },2000);

                            if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                        },
                        error: function () {
                            button.prop('disabled',false);
                            buttonTextEl.html(buttonTextValue);
                            alert('Could not add item to cart. Please try again.');
                        }
                    });
                });
                
            
            break;

            case 'single':

                buttonTextEl.html('Preparing Your Protocol...');

                var specialOfferVariantID = parseInt(button.attr('data-variant-id'));
                var specialOfferVariantSellingPlanID = parseInt(button.attr('data-selling-plan-id'));

                var formData = {
                items: [
                    {
                        id: specialOfferVariantID,
                        quantity: 3,
                        selling_plan: specialOfferVariantSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'onelife_90d',
                            '_bundle_group_id' : 'onelife_90d',
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            '_offer' : 'onelife_90d',
                            '_offer_product_type' : 'primary',
                            _order_from : orderFrom
                        }
                    }
                ]
                };

                if (false && !bottleOOS) /*free gift off*/ {
                    formData.items.push(
                        {
                            id: 53301741289656, // Free bottle variant ID
                            quantity: 1,
                            properties : {
                                '_offer' : 'onelife_90d',
                                '_offer_product_type' : 'free',
                                _order_from : orderFrom
                            }
                        }
                    );
                }

                // if (false && !frotherOOS) /*free gift off*/ {
                //     formData.items.push(
                //         {
                //             id: 52887363551416, // Free frother variant ID
                //             quantity: 1,
                //             properties : {
                //                 '_offer' : 'onelife_90d',
                //                 '_offer_product_type' : 'free',
                //                 _order_from : orderFrom
                //             }
                //         }
                //     );
                // }

                // 1️⃣ Check cart first
                $.getJSON('/cart.js', function(cart) {
                    const hasItems = cart.item_count > 0;

                    // 2️⃣ Add to cart
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify(formData),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function () {
                            
                            setTimeout(function(){
                                    button.prop('disabled',false);
                                    buttonTextEl.html(buttonTextValue);
                            },2000);

                            if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                        },
                        error: function () {
                            button.prop('disabled',false);
                            buttonTextEl.html(buttonTextValue);
                            alert('Could not add item to cart. Please try again.');
                        }
                    });
                });
            
            break;

            case 'one-time':

                buttonTextEl.html('Preparing Your Protocol...');
                var specialOfferVariantID = parseInt(button.attr('data-variant-id'));

                var formData = {
                items: [
                    {
                        id: specialOfferVariantID,
                        quantity: 1,
                        properties : {
                            // '_BUNDLE' : 'onefit_onetime',
                            // '_bundle_group_id' : 'onefit_onetime',
                            // "_bundle_group_product" : true,
                            // "_bundle_group_product_row" : 1,
                            // '_offer' : 'onefit_onetime',
                            // '_offer_product_type' : 'primary',
                            _order_from : orderFrom
                        }
                    }
                ]
                };

                if (false && !bottleOOS) /*free gift off*/ {
                    formData.items.push(
                        {
                            id: 53301741289656, // Free bottle variant ID
                            quantity: 1,
                            // properties : {
                            //     '_offer' : 'onefit_onetime',
                            //     '_offer_product_type' : 'free',
                            //     _order_from : orderFrom
                            // }
                        }
                    );
                }

                // if (false && !frotherOOS) /*free gift off*/ {
                //     formData.items.push(
                //         {
                //             id: 52887363551416, // Free frother variant ID
                //             quantity: 1,
                //             // properties : {
                //             //     '_offer' : 'onefit_onetime',
                //             //     '_offer_product_type' : 'free',
                //             //     _order_from : 'hybrid'
                //             // }
                //         }
                //     );
                // }


                
                
                // 1️⃣ Check cart first
                $.getJSON('/cart.js', function(cart) {
                    const hasItems = cart.item_count > 0;

                    // 2️⃣ Add to cart
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify(formData),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function () {
                            
                            setTimeout(function(){
                                    button.prop('disabled',false);
                                    buttonTextEl.html(buttonTextValue);
                            },2000);

                            if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                        },
                        error: function () {
                            button.prop('disabled',false);
                            buttonTextEl.html(buttonTextValue);
                            alert('Could not add item to cart. Please try again.');
                        }
                    });
                });
                
            break;
        }

    });

    // $(window).on('load',function(){
    //     if ($(window).width() < 768) {
    //         $('.gift-product__card').removeClass('gift-product__card--active');
    //         $('.gift-product__card[data-tab="duo"]').addClass('gift-product__card--active');
    //         checkPerDay();
    //     }
    // });


    initNearView(document.querySelector('.swiper-horizontal-onefit-in-store'), function () {
    const swiperOnefit = new Swiper('.swiper-horizontal-onefit-in-store', {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 'auto', // important for smooth continuous flow
        spaceBetween: 16,
        allowTouchMove: true,

        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },

        speed: 40000, // lower = faster, higher = slower smooth scroll

        freeMode: {
            enabled: true,
            momentum: false,
        },

        grabCursor: true,

        breakpoints: {
            0: {
            slidesPerView: 1.5,
            },
            640: {
            slidesPerView: 2.5,
            },
            1024: {
            slidesPerView: 3,
            },
        },
    });
    pauseOffscreen(document.querySelector('.swiper-horizontal-onefit-in-store'), swiperOnefit);
    });

    initNearView(document.querySelector('.swiper-conquesting-reviews'), function () {
    var reviewsSwiper = new Swiper(".swiper-conquesting-reviews", {
        loop: true,
        spaceBetween: 45,
        roundLengths: true,
        speed: 600, // slide transition speed in ms
        autoplay: {
            delay: 2500, // time between slides in ms
            disableOnInteraction: false, // keeps autoplay going after user swipes
            pauseOnMouseEnter: true, // pauses when user hovers
        },
        breakpoints: {
            0: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 4.4, // fixed typo (had "4.2t")
            }
        }
    });
    });


   
    var wrapper = $('.conquesting-compare-body-wrapper');
    var container = wrapper.find('.container');
    var defaultHeight = 1025; // default height in px

    $('.conquesting-compare-button button').on('click', function() {
        console.log('Button clicked!');

       


        if (!wrapper.hasClass('active')) {

            $(this).addClass('active').find('span').html('Click to Close Here');
            
            // Add active class
            wrapper.addClass('active');

            // Get total content height
            var fullHeight = container.get(0).scrollHeight;

            // Animate container to full height
            container.css('height', fullHeight + 'px');
        } else {

            

            $(this).removeClass('active');
            $(this).find('span').html('Expand To Compare More');


            

            // Remove active class
            wrapper.removeClass('active');

            // Reset container to default height
            container.css('height', defaultHeight + 'px');
        }
    });
   
    


    
    const $section = $('#section-whats-inside');
    const $container = $section.find('.of-inside-container');

    // if (!$container.length) return;
    if ($container.length){
        // Duplicate content ONCE
        $container.append($container.html());

        let speed = 0.25;          // visual speed
        let paused = false;
        let currentScroll = 0;    // float accumulator

        // $container.on('mouseenter', () => paused = true);
        // $container.on('mouseleave', () => paused = false);

        var running = false;
        function infiniteScroll() {
        if (!paused) {
            currentScroll += speed;

            const halfHeight = $container[0].scrollHeight / 2;

            if (currentScroll >= halfHeight) {
            currentScroll -= halfHeight; // seamless reset
            }

            $container.scrollTop(Math.floor(currentScroll));
        }

        if (running) requestAnimationFrame(infiniteScroll);
        }

        // Run the marquee only while it is on screen: the rAF loop otherwise burns
        // main-thread time for the whole page lifetime (shows as large TBT in traces).
        if ('IntersectionObserver' in window) {
          var marqueeVis = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
              if (!running) { running = true; requestAnimationFrame(infiniteScroll); }
            } else {
              running = false;
            }
          }, { rootMargin: '100px 0px' });
          marqueeVis.observe($container[0]);
        } else {
          running = true;
          requestAnimationFrame(infiniteScroll);
        }
    }


    $('.open-supplement-facts').magnificPopup({
        type: 'inline'
    });

    $('.ingredient-item h3').each(function () {
        $(this).attr('data-feature', $(this).html());
    });

    $('.index-2026-tabs [data-product]').on('click', function () {

        const product = $(this).data('product');


        // toggle active tab
        $('.index-2026-tabs [data-product]').removeClass('active');
        $('.index-2026-tabs [data-product="'+product+'"]').addClass('active');

        // toggle matching slide
        // $('.tab-toggle[data-product]').removeClass('active');
        // $('.tab-toggle[data-product="' + product + '"]').addClass('active');    

        if (product == 'features'){
            $('.ingredient-item h3').each(function () {
                $(this).html($(this).data('feature'));
            });
        }else{
            $('.ingredient-item h3').each(function () {
                $(this).html($(this).data('benefit'));
            });
        }


        


    });


    

    function open90DaySystem(){
  
    
        // 1️⃣ Replace default close button with custom SVG
        $.magnificPopup.defaults.closeMarkup = `
            <button title="%title%" type="button" class="mfp-close">
                <img
                src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/material-symbols-light_close_3c5246f4-0d73-4b25-b065-35f56cebbb0d.svg?v=1768531797"
                alt="Close"
                />
            </button>
            `;
            $.magnificPopup.open({
            items: {
                src: '#popup-90-day-system'
            },
            type: 'inline'
        });
    
    }
    function open30DaySystem(){
  
    
        // 1️⃣ Replace default close button with custom SVG
        $.magnificPopup.defaults.closeMarkup = `
            <button title="%title%" type="button" class="mfp-close">
                <img
                src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/material-symbols-light_close_3c5246f4-0d73-4b25-b065-35f56cebbb0d.svg?v=1768531797"
                alt="Close"
                />
            </button>
            `;
            $.magnificPopup.open({
            items: {
                src: '#popup-30-day-system'
            },
            type: 'inline'
        });
    
    }

    $('.popup-90-products .variant-item').on('click', function (e) {

        // Reset
        // $('.popup-90-products .variant-item').removeClass('active');
        $(this).toggleClass('active');

        $('#popup-90-btn-continue').prop('disabled',false);

        add90ProductsItem($(this));

    });

    var selectedItems = [];
    var selectedCartItems = [];

    function add90ProductsItem(variant,forceAdd = false){


        var variantID = variant.attr('data-variant-id');
        var sellingPlanID = parseInt(variant.attr('data-selling-plan-id'));
        var variantPrice = variant.attr('data-price');
        var originalPrice = variant.attr('data-original-price');

        var description = variant.find('p').html();

        console.log('add90ProductsItem variantID',variantID);

        $('#popup-90-day-system .popup-flavour-description').html(description);

        if (forceAdd){
        selectedItems.push(variantID);
        
        }else{
            if (variant.hasClass('active')){
                variant.find('button').html('Selected');
                selectedItems.push(variantID);
            }else{
                variant.find('button').html('Select');
                
                let index = selectedItems.indexOf(variantID);
                if (index > -1) {
                selectedItems.splice(index, 1);
                }
            }
        }

        console.log('forceAdd',forceAdd);
        console.log('selectedItems',selectedItems);

        // Define quantities based on number of selected items
        const quantitiesMap = {
            1: [5],
            2: [3, 2],
            3: [3, 1, 1],
            4: [2, 1, 1, 1],
            5: [1, 1, 1, 1, 1] // for 5 items
        };

        // Get the quantities for the current selectedItems length
        const quantities = quantitiesMap[selectedItems.length] || [];

        // Map selectedItems to selectedCartItems
        selectedCartItems = selectedItems.map((id, index) => ({
            id,
            selling_plan_id: sellingPlanID,
            price: variantPrice,
            quantity: quantities[index] || 1 // default to 1 if not defined
        }));

        console.log(selectedCartItems);


        $('#popup-90-btn-continue').prop('disabled',true);
        if (selectedItems.length){
            $('#popup-90-btn-continue').prop('disabled',false);
        }
    }

    $('#popup-90-btn-continue').on('click',function(){


        if (!selectedCartItems || !selectedCartItems.length) return;

        var button = $(this);
        button.prop('disabled',true);
        
        var buttonTextValue = button.html();

        button.html('Preparing Your Protocol...');
        
        var specialOfferVariant = $('.popup-90-products .variant-item.active');
        var specialOfferVariantID = parseInt(specialOfferVariant.attr('data-variant-id'));
        var specialOfferVariantSellingPlanID = parseInt(specialOfferVariant.attr('data-selling-plan-id'));


        const itemsToAdd = [];
        const _bundle_group_id = Math.floor(Date.now() / 1000);

         var formData = {
            items: []
        };

        var orderFrom = 'conquesting_' + $('.gift-product').data('page');
        

        selectedCartItems.forEach((item, index) => {
          
            // All other items are regular products
            // itemsToAdd.push({
            //   id: item.id,
            //   quantity: item.quantity
            // });

            var rowIndex = index + 1;

            formData.items.push({
                id: item.id,
                quantity:item.quantity,
                selling_plan: item.selling_plan_id,
                properties : {
                    '_BUNDLE' : 'onefit_90d_conquesting',
                    '_bundle_group_id' : 'onefit_90d_conquesting_' + _bundle_group_id,
                    "_bundle_group_product" : true,
                    "_bundle_group_product_row" : rowIndex,
                    '_offer' : 'onefit_90d_conquesting',
                    "_bundle_group_product_multiplier" : item.quantity,
                    '_offer_product_type' : 'primary',
                    _order_from : orderFrom
                }
            });
          
        });

       

        if (false && !bottleOOS) /*free gift off*/ {
            formData.items.push(
                {
                    id: 53301741289656, // Free bottle variant ID
                    quantity: 1,
                    properties : {
                        '_offer' : 'onefit_90d_conquesting',
                        '_offer_product_type' : 'free',
                        _order_from : orderFrom
                    }
                }
            );
        }

        // if (false && !frotherOOS) /*free gift off*/ {
        //     formData.items.push(
        //         {
        //             id: 52887363551416, // Free frother variant ID
        //             quantity: 1,
        //             properties : {
        //                 '_offer' : 'onefit_90d_conquesting',
        //                 '_offer_product_type' : 'free',
        //                 _order_from : orderFrom
        //             }
        //         }
        //     );
        // }

        
        // 1️⃣ Check cart first
        $.getJSON('/cart.js', function(cart) {
            const hasItems = cart.item_count > 0;

            // 2️⃣ Add to cart
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify(formData),
                dataType: 'json',
                contentType: 'application/json',
                success: function () {
                    
                    $.magnificPopup.close();


                    setTimeout(function(){
                            button.prop('disabled',false);
                            button.html(buttonTextValue);
                    },2000);

                    if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                },
                error: function () {
                    button.prop('disabled',false);
                    button.html(buttonTextValue);
                    alert('Could not add item to cart. Please try again.');
                }
            });
        });
    });


    // 30 d

    $('.popup-30-products .variant-item').on('click', function (e) {

        // Reset
        $('.popup-30-products .variant-item').removeClass('active');
        $(this).toggleClass('active');

        $('#popup-30-btn-continue').prop('disabled',false);

    });

    $('#popup-30-btn-continue').on('click',function(){

        var button = $(this);
        button.prop('disabled',true);
        
        var buttonTextValue = button.html();

        button.html('Preparing Your Monthly Supply...');
        
        var specialOfferVariant = $('.popup-30-products .variant-item.active');
        var specialOfferVariantID = parseInt(specialOfferVariant.attr('data-variant-id'));
        var specialOfferVariantSellingPlanID = parseInt(specialOfferVariant.attr('data-selling-plan-id'));

        var orderFrom = 'conquesting_' + $('.gift-product').data('page');

        var formData = {
        items: [
            {
                id: specialOfferVariantID,
                quantity: 1,
                selling_plan: specialOfferVariantSellingPlanID,
                properties : {
                    _order_from : orderFrom
                }
            }
        ]
        };

        if (false && !bottleOOS) /*free gift off*/ {
            formData.items.push({
                id: 53301741289656, // Free bottle variant ID
                quantity: 1,
                properties : {
                    _order_from : orderFrom
                }
            });
        }

        // 1️⃣ Check cart first
        $.getJSON('/cart.js', function(cart) {
            const hasItems = cart.item_count > 0;

            // 2️⃣ Add to cart
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify(formData),
                dataType: 'json',
                contentType: 'application/json',
                success: function () {
                    
                    $.magnificPopup.close();


                    setTimeout(function(){
                            button.prop('disabled',false);
                            button.html(buttonTextValue);
                    },2000);

                    if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                },
                error: function () {
                    button.prop('disabled',false);
                    button.html(buttonTextValue);
                    alert('Could not add item to cart. Please try again.');
                }
            });
        });
        
        
        
    });
    

    function showOutOfStockPopup(variantID){
      $.magnificPopup.open({
        items: {
          src: '#klaviyo-oos-' + variantID // This is the ID of the hidden div
        },
        type: 'inline'
      });
    }

    if (productOOS){
      showOutOfStockPopup('onelife');
    }

   

});